import { AGENT_MODEL, TestMode } from '@nrwl/common-lib';
import { HttpConfigFieldMapping, testTypeValue } from '../models/models';

export const HTTP_AGENT_MODEL_CONFIG = {
  id: 'http_test',
  agentConfig: {
    default: {
      setup: {
        //setup page model
        alias: {
          enabled: true,
          value: 'HTTP',
          outputField: HttpConfigFieldMapping.ALIAS,
          tabId: 'http_setup',
          restoreOnAgentChange: true
        },
        customer: {
          enabled: true,
          value: '',
          outputField: 'customer',
          tabId: 'http_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        technician: {
          enabled: true,
          value: '',
          outputField: 'technician',
          tabId: 'http_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        contact: {
          enabled: true,
          value: '',
          outputField: 'contact',
          tabId: 'http_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        email: {
          enabled: true,
          value: '',
          outputField: 'email',
          tabId: 'http_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        phone: {
          enabled: true,
          value: '',
          outputField: 'phone',
          tabId: 'http_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        technicianId: {
          enabled: true,
          value: '',
          outputField: 'technicianId',
          tabId: 'http_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        comments: {
          enabled: true,
          value: '',
          outputField: 'comments',
          tabId: 'http_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        runType: {
          enabled: true,
          value: 'on-going',
          outputField: HttpConfigFieldMapping.RUN_TYPE,
          tabId: 'http_setup',
          restoreOnAgentChange: true
        },
        scheduler: {
          enabled: true,
          value: { repeatInterval: 0, timeStamp: '', endTime: 90, isValid: true },
          outputField: HttpConfigFieldMapping.SCHEDULER,
          tabId: 'http_setup',
          restoreOnAgentChange: true
        },
        engineAInfo: {
          enabled: true,
          value: null,
          outputField: HttpConfigFieldMapping.ENGINE_A_INFO,
          tabId: 'http_setup',
          restoreOnAgentChange: true
        },
        engineBInfo: {
          enabled: false,
          value: null,
          outputField: HttpConfigFieldMapping.ENGINE_B_INFO,
          tabId: 'http_setup'
        },
        agentType: {
          enabled: true,
          value: 'default',
          outputField: HttpConfigFieldMapping.AGENT_TYPE,
          tabId: 'http_setup'
        },
        testMode: {
          enabled: true,
          value: TestMode.MA_TO_SERVER,
          outputField: HttpConfigFieldMapping.TEST_MODE,
          tabId: 'http_setup',
          restoreOnAgentChange: true
        },
        direction: {
          enabled: true,
          value: TestMode.UPLOAD,
          outputField: HttpConfigFieldMapping.DIRECTION,
          tabId: 'http_setup',
          restoreOnAgentChange: true
        },
        selectedOriginator: {
          enabled: true,
          value: null,
          outputField: HttpConfigFieldMapping.SELECTED_ORIGINATOR,
          tabId: 'http_setup',
          restoreOnAgentChange: true
        },
        selectedDestination: {
          enabled: true,
          value: null,
          outputField: HttpConfigFieldMapping.SELECTED_DESTINATION,
          tabId: 'http_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        type: {
          enabled: true,
          value: testTypeValue.HTTP,
          outputField: HttpConfigFieldMapping.TEST_TYPE,
          tabId: 'http_setup',
          restoreOnAgentChange: true
        },
        tcpPort: {
          enabled: true,
          value: 0,
          outputField: HttpConfigFieldMapping.TCP_PORT,
          tabId: 'http_setup'
        },
        threshold: {
          enabled: true,
          value: true,
          outputField: HttpConfigFieldMapping.THRESHOLD_ENABLED,
          tabId: 'http_setup',
          restoreOnAgentChange: true
        },
        uploadThreshold: {
          enabled: true,
          value: 90,
          outputField: HttpConfigFieldMapping.ENGINE_A_TO_B_THRESHOLD,
          tabId: 'http_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        downloadThreshold: {
          enabled: true,
          value: 90,
          outputField: HttpConfigFieldMapping.ENGINE_B_TO_A_THRESHOLD,
          tabId: 'http_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        target: {
          enabled: true,
          value: true,
          outputField: HttpConfigFieldMapping.TARGET_ENABLED,
          tabId: 'http_setup',
          restoreOnAgentChange: true
        },
        uploadTarget: {
          enabled: true,
          value: 100,
          outputField: HttpConfigFieldMapping.ENGINE_A_TO_B_TARGET,
          tabId: 'http_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        downloadTarget: {
          enabled: true,
          value: 100,
          outputField: HttpConfigFieldMapping.ENGINE_B_TO_A_TARGET,
          tabId: 'http_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        uploadExternalURL: {
          enabled: true,
          value: 'http://192.168.0.1/sample/url.html',
          outputField: HttpConfigFieldMapping.ENGINE_A_TO_B_URL,
          tabId: 'http_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        },
        downloadExternalURL: {
          enabled: true,
          value: 'http://192.168.0.1/sample/url.html',
          outputField: HttpConfigFieldMapping.ENGINE_B_TO_A_URL,
          tabId: 'http_setup',
          outputOptional: true,
          restoreOnAgentChange: true
        }
      },

      running: {
        add: 'anything that is different between agents in running view'
      },

      final: {
        add: 'anything that is different between agents in final report'
      },
      modes: {
        [TestMode.MA_TO_SERVER]: {
          setup: {
            uploadExternalURL: { enabled: false },
            downloadExternalURL: { enabled: false }
          }
        },
        [TestMode.MA_TO_EXTERNAL]: {
          setup: {
            engineBInfo: { enabled: false },
            uploadExternalURL: { enabled: true },
            downloadExternalURL: { enabled: true }
          }
        }
      }
    },
    [AGENT_MODEL.VTA]: {
      setup: {
        runExclusive: { enabled: true },
        engineBInfo: { enabled: true }
      },
      modes: {
        [TestMode.MA_TO_SERVER]: {
          setup: {
            engineBInfo: { enabled: true },
            uploadExternalURL: { enabled: false },
            downloadExternalURL: { enabled: false }
          }
        },
        [TestMode.MA_TO_EXTERNAL]: {
          setup: {
            engineBInfo: { enabled: false },
            uploadExternalURL: { enabled: true },
            downloadExternalURL: { enabled: true }
          }
        }
      }
    },
    [AGENT_MODEL.VSPA_SAT]: {
      setup: {
        runExclusive: { enabled: true },
        engineBInfo: { enabled: true }
      },
      modes: {
        [TestMode.MA_TO_SERVER]: {
          setup: {
            engineBInfo: { enabled: true },
            uploadExternalURL: { enabled: false },
            downloadExternalURL: { enabled: false }
          }
        },
        [TestMode.MA_TO_EXTERNAL]: {
          setup: {
            engineBInfo: { enabled: false },
            uploadExternalURL: { enabled: true },
            downloadExternalURL: { enabled: true }
          }
        }
      }
    }
  }
};
